import {
  BOOKAPPOINTMENTREQ,
  BOOKAPPOINTMENTSUCCESS,
  BOOKAPPOINTMENTFAILED,
} from "../actions/appointmentActions";

const initialState = {
  loading: false,
  appointmentData: null,
  error: null,
};

export const appointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOKAPPOINTMENTREQ:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case BOOKAPPOINTMENTSUCCESS:
      return {
        ...state,
        loading: false,
        appointmentData: action.payload,
        error: null,
      };

    case BOOKAPPOINTMENTFAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default appointmentReducer;
